export default {
    methods: {
        kebabCase(str){
            return _.kebabCase(str);
        },
    },
}